import { Create } from "react-admin";
import WeightReportOperationForm from "./WeightReportOperationForm";

const WeightReportOperationCreate = () => (
    <Create title={<span>Crear Registro de Exportación</span>}>
        <WeightReportOperationForm />
    </Create>
);

export default WeightReportOperationCreate;
